import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { AppState } from '../../../data/state'

interface FlexibleRebookingProps {
  flexibleRebooking: boolean
}

const FlexibleRebooking: React.FC<FlexibleRebookingProps> = ({
  flexibleRebooking,
}) => {
  return flexibleRebooking ? (
    <ListItem>
      <DisplayContent addNode contentKey="flexible-rebooking-summary">
        Flexible Rebooking
      </DisplayContent>
    </ListItem>
  ) : null
}

export default connect((state: AppState) => ({
  flexibleRebooking: state.funnelOrder.flexibleRebooking,
}))(FlexibleRebooking)
